import { brandMarkPath } from "./BrandLockup";

type FooterLink = {
  href: string;
  label: string;
};

type FooterProps = {
  brand: string;
  message: string;
  links?: FooterLink[];
};

export function Footer({ brand, message, links }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer">
      <div className="foot-brand" aria-label={brand}>
        <img className="foot-logo" src={brandMarkPath} alt="" aria-hidden="true" />
      </div>
      {links ? (
        <div className="foot-links">
          {links.map((link) => (
            <a key={`${link.href}-${link.label}`} href={link.href}>{link.label}</a>
          ))}
        </div>
      ) : null}
      <span className="foot-copy">© {currentYear} {message}</span>
    </div>
  );
}
